/**
 * Shared BIM/CAD file rail headings (deliverable library + VirtualSpace share).
 * File-type rails use Nasalization display slightly larger than floor bands.
 */
export const BIM_FILE_TYPE_HEADING_CLASS =
  "vs-font-brand-display text-sm sm:text-base uppercase tracking-[0.1em] text-(--vs-red-text)";

/** File count next to the type label — stays in body sans at small size. */
export const BIM_FILE_TYPE_COUNT_CLASS =
  "text-[10px] sm:text-[11px] text-muted-foreground font-normal tracking-normal normal-case";

export const BIM_FLOOR_BAND_ROW_CLASS =
  "list-none border-t border-(--vs-red-text)/15 bg-(--vs-red-light)/60 px-3 py-2 first:border-t-0";

export const BIM_FLOOR_BAND_TITLE_CLASS =
  "vs-font-brand text-[11px] sm:text-[12px] uppercase tracking-widest text-(--vs-red-text)";
